import { isElementInViewport } from '@theme/utilities';

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.onScroll = this.onScroll.bind(this);
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');

    this.onScroll();

    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    this.dataset.active = isElementInViewport(this.form) ? 'false' : 'true';
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}